import { render, staticRenderFns } from "./SettingsElement.vue?vue&type=template&id=6fe9e056&scoped=true&"
import script from "./SettingsElement.vue?vue&type=script&lang=js&"
export * from "./SettingsElement.vue?vue&type=script&lang=js&"
import style0 from "./SettingsElement.vue?vue&type=style&index=0&id=6fe9e056&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe9e056",
  null
  
)

export default component.exports